<template>
  <div class="el-parameter-editor-item">
    <h1>{{ title }} ({{ replacerName }})</h1>
    <el-form class="el-parameter-editor-item-form">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Выберите значение" prop="id">
            <el-select
              class="el-parameter-editor-item-select"
              v-model="current_value"
              size="small"
              placeholder="Выберите значение"
              filterable
              @change="onChange"
            >
              <el-option
                v-for="enumVal in available_values"
                :key="enumVal.id"
                :label="enumVal.text"
                :value="enumVal"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item prop="isClientEditable">
            <el-checkbox
              size="small"
              true-label=1
              false-label=0
              :checked="is_client_editable==1"
              v-model="is_client_editable"
              @change="onChange"
            >Доступно клиенту для редактирования</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { required } from "@/core/helpers/validators";

export default {
  name: "EnumEditor",
  model: {
    prop: "item-id",
    event: "change",
  },
  props: {
    title: {
      type: String,
      default: "Заголовок",
    },
    availableValues: {
      type: Array,
      default: function() {},
    },
    currentValue: {
      type: Object,
      default: function() {},
    },
    isClientEditable: {
      type: Number,
      default: 0
    },
    replacerName: {
      type: String,
      default: "#replacer",
    },
  },
  data() {
    return {
      available_values: this.availableValues,
      current_value: this.currentValue,
      is_client_editable: this.isClientEditable,
      rules: {
        available_values: [required()],
        current_values: [required()],
        is_client_editable: [required()],
      }
    };
  },
  beforeDestroy() {
    this.onDelete();
  },
  methods: {
    onChange() {
      this.$emit("updateValues", {
        replacer: this.replacerName,
        current_value: this.current_value,
        is_client_editable: this.is_client_editable
      });
    },
    onDelete() {
      this.$emit("removeEditor", {
        replacer: this.replacerName,
      });
    },
  },
};
</script>

<style>
div .el-parameter-editor-item {
  border: thin solid #3883fa;
  margin-top: 5px;
  padding: 0 10px;
}

.el-parameter-editor-item-form {
  max-width: 100%;
}

.el-parameter-editor-item-select {
  width: 100%;
}
</style>
